<template>
    <div>
        <GmapMap :center="mapCenter" :zoom="13" style="width: 100%; height: 500px" :options="{mapTypeControl: false}" v-bind:options="mapStyle">
            <GmapMarker :key="index" v-for="(m, index) in markers" :position="{ lat: m.lat, lng: m.lng }" :icon="markerIcon"
                @click="openInfoWindow(m)">
                <GmapInfoWindow :options="{ maxWidth: 200 }" :position="{ lat: m.lat, lng: m.lng }"
                    :opened="m === currentMarker" @closeclick="currentMarker = null">
                    <div class="info-content"><a :href=m.link>{{ m.info }}</a></div>
                </GmapInfoWindow>
            </GmapMarker>
        </GmapMap>
    </div>
</template>
  
<script>
export default {
    name: 'Gmaps',
    props: {
        markers: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            currentMarker: null,
            markerIcon: `https://victoriadivision.ca/wp-content/uploads/2024/07/map-pin-gm.png`,
            mapStyle: {
                mapTypeControl: false,
                styles:[ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#b5b5b5" }, { "visibility": "on" }, { "weight": "2.00" } ] }, { "featureType": "road.highway", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road.arterial", "elementType": "all", "stylers": [ { "visibility": "on" }, { "color": "#b5b5b5" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#cae9f2" }, { "visibility": "on" } ] } ]
            },

        }
    },
    computed: {
        mapCenter() {
            if (this.markers.length) { //48.429455, -123.365445
                return {
                    lat: 48.429455,
                    lng: -123.365445
                }
            }
            return { lat: 48.429455, lng: -123.365445 };
        }
    },
    methods: {
        openInfoWindow(marker) {
            this.currentMarker = marker;
        }
    }
}
</script>
  
<style scoped>
.info-content {
    padding: 10px;
    color: #016d89;
    font-family: "Myriad Pro Regular", Sans-serif;
    font-weight: 500;
    font-size: 16px;
    font-weight: bold;
}

.info-content a {
    color: #016d89 !important;
}
</style>
  



// WEBPACK FOOTER //
// src/components/Gmaps.vue